/** Creature meshes. Primitives below reuse the scene shapes. */
export const CHARACTER_GLB_FIGURES = ["humanoid", "quadruped", "biped"] as const

export const CHARACTER_PRIMITIVE_FIGURES = ["box", "sphere", "cylinder", "cone"] as const

export const CHARACTER_FIGURE_IDS = [...CHARACTER_GLB_FIGURES, ...CHARACTER_PRIMITIVE_FIGURES] as const

export type SceneCharacterGlbFigure = (typeof CHARACTER_GLB_FIGURES)[number]
export type SceneCharacterFigure = (typeof CHARACTER_FIGURE_IDS)[number]

const GLB_URL: Record<SceneCharacterGlbFigure, string> = {
  humanoid: "/scene3d/character-humanoid.glb",
  quadruped: "/scene3d/character-quadruped.glb",
  biped: "/scene3d/character-biped.glb",
}

export function isCharacterFigure(value: unknown): value is SceneCharacterFigure {
  return typeof value === "string" && (CHARACTER_FIGURE_IDS as readonly string[]).includes(value)
}

/** Missing or unknown figure draws the humanoid. Does not write the field back. */
export function characterFigureOrHumanoid(value: unknown): SceneCharacterFigure {
  return isCharacterFigure(value) ? value : "humanoid"
}

export function characterFigureGlbUrl(figure: SceneCharacterFigure): string | null {
  if (figure === "humanoid" || figure === "quadruped" || figure === "biped") return GLB_URL[figure]
  return null
}

export function characterFigureShape(
  figure: SceneCharacterFigure,
): (typeof CHARACTER_PRIMITIVE_FIGURES)[number] | null {
  if (figure === "humanoid" || figure === "quadruped" || figure === "biped") return null
  return figure
}
